import { OrgRole } from '../../core-models';

export const ORG_ROLE_LABEL: Record<OrgRole, string> = {
    [OrgRole.Member]: 'Member',
    [OrgRole.Admin]: 'Admin',
    [OrgRole.Owner]: 'Owner',
};

export const ORG_ROLE_DESCRIPTION: Record<OrgRole, string> = {
    [OrgRole.Owner]:
        'Full organisation access. Can manage users, building access, settings, building create and publish, invite owners, and delete the organisation.',
    [OrgRole.Admin]:
        'Can manage users, building access, settings, and building create and publish. Cannot invite owners or delete the organisation.',
    [OrgRole.Member]:
        'No organisation-wide permissions. Building access is assigned separately per building.',
};
